export const AUTO_CLOSE_DELAY = 7000
